export const colors = [
  { label: "Silver Brilliant Metallic", value: "white", price: 800 },
  { label: "Black Magic Metallic", value: "black", price: 800 },
  { label: "Deep Blue Metallic", value: "blue", price: 1500 },
  { label: "Red Velvet Metallic", value: "red", price: 1000 }
];

export const interiorColors = [
  { label: "All black Figured Ash Wood Décor", value: "all_black", price: 0 },
  { label: "Black and white Dark Ash Wood Décor", value: "black_and_white", price: 1500 },
  { label: "Cream Oak Wood Décor", value: "cream", price: 1500 },
];

export const interiorLayouts = [
  { label: "Five seat interior", value: "five_seat", price: 0 },
  { label: "Six seat interior", value: "six_seat", price: 6500 },
  { label: "Seven seat interior", value: "seven_seat", price: 3500 },
];

export const models = [
  {
    key: 's',
    name: "Elroq",
    colors: colors,
    wheels: [
      {
        src: `${process.env.PUBLIC_URL}/wheels/model_s/model_s_wheel_1.png`,
        label: '19" Proteus Wheels',
        value: "wheel_1",
        price: 0
      },
      {
        src: `${process.env.PUBLIC_URL}/wheels/model_s/model_s_wheel_2.png`,
        label: '20" Vega Wheels',
        value: "wheel_2",
        price: 800
      }
    ],
    types: [
      {
        label: "Essence 50",
        value: "long_range_plus",
        specs: {
          range: 377,
          top_speed: 180,
          acceleration_time: 9.0,
        },
        price: 31960
      },
      {
        label: "Essence 60",
        value: "performance",
        specs: {
          range: 430,
          top_speed: 180,
          acceleration_time: 8.0,
        },
        price: 35280,
        benefits: [
          "Quicker acceleration: 0-60 mph in 2.3s",
          "Ludicrous Mode",
          "Enhanced Interior Styling",
          "Carbon fiber spoiler"
        ]
      },
      {
        label: "Selection 85",
        value: "plaid",
        specs: {
          range: 574,
          top_speed: 180,
          acceleration_time: 6.6,
        },
        price: 41280,
        benefits: [
          "Quickest 0-60 mph and quarter mile acceleration of any production car ever",
          "Acceleration from 0-60 mph: <2.0s",
          "Quarter mile: <9.0s",
          "1,100+ horsepower",
          "Tri Motor All-Wheel Drive"
        ]
      },
    ],
    interiorColors: interiorColors
  },
  {
    key: 'x',
    name: "Enyaq",
    colors: colors,
    wheels: [
      {
        src: `${process.env.PUBLIC_URL}/wheels/model_x/model_x_wheel_1.png`,
        label: '19" Proteus Wheels',
        value: "wheel_1",
        price: 0
      },
      {
        src: `${process.env.PUBLIC_URL}/wheels/model_x/model_x_wheel_2.png`,
        label: '20" Neptune Wheels',
        value: "wheel_2",
        price: 5500
      }
    ],
    types: [
      {
        label: "Selection 60",
        value: "long_range_plus",
        specs: {
          range: 435,
          top_speed: 180,
          acceleration_time: 8.1
        },
        price: 40600
      },
      {
        label: "Selection 85",
        value: "performance",
        specs: {
          range: 581,
          top_speed: 180,
          acceleration_time: 6.7
        },
        price: 45200,
        benefits: [
          "Quicker acceleration: 0-60 mph in 2.6s",
          "Ludicrous Mode",
          "Enhanced Interior Styling"
        ]
      }
    ],
    interiorColors: interiorColors,
    interiorLayouts: interiorLayouts
  }
];

export const initialConfig = {
  's': {
    car_type: "long_range_plus",
    model: "s",
    color: "white",
    wheels: "wheel_1",
    interior_color: "all_black"
  },
  'x': {
    car_type: "long_range_plus",
    model: "x",
    color: "white",
    wheels: "wheel_1",
    interior_color: "all_black",
    interior_layout: "five_seat"
  }
};
